import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { getIconColorSVGFill } from '../../tools/colors.js';
import css_248z from './icons.styles.css.js';

let LongArrowUpIcon = class LongArrowUpIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.color = 'iconNeutralSoft';
        this.size = 24; // Default size
    }
    render() {
        return html `
      <svg
        width=${this.size}
        height=${this.size}
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M0.944336 5.59715L1.91775 6.57057L5.7769 2.71832V11.1201H7.15764V2.71832L11.0099 6.57747L11.9902 5.59715L6.46727 0.0742188L0.944336 5.59715Z"
          fill=${this.color ? getIconColorSVGFill(this.color) : 'currentColor'}
        />
      </svg>
    `;
    }
};
LongArrowUpIcon.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], LongArrowUpIcon.prototype, "color", void 0);
__decorate([
    property({ type: Number })
], LongArrowUpIcon.prototype, "size", void 0);
LongArrowUpIcon = __decorate([
    customElement('long-arrow-up-icon')
], LongArrowUpIcon);
var LongArrowUpIcon$1 = LongArrowUpIcon;

export { LongArrowUpIcon$1 as default };
//# sourceMappingURL=longArrowUpIcon.js.map
